<div class="container-fluid mt-4">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h4 class="mb-0">
      <i class="fi fi-rr-picture"></i> გალერეა
    </h4>

    <span class="text-muted small" *ngIf="sorting">სორტირება ინახება...</span>
  </div>

  <!-- select + upload -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-3 align-items-end">
        <div class="col-lg-6">
          <div class="form-floating">
            <select
              class="form-select"
              [ngModel]="selectedMenuPage"
              (ngModelChange)="onPageChange($event)">
              <option [ngValue]="null">აირჩიე გალერეის გვერდი...</option>
              <option *ngFor="let p of pages" [ngValue]="p.menu_page">
                {{ p.title }} ({{ p.menu_page }})
              </option>
            </select>
            <label>გალერეის გვერდი</label>
          </div>
          <div class="form-text" *ngIf="selectedMenuPage">
            არჩეული: <b>{{ selectedMenuPage }}</b>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="d-flex gap-2 justify-content-end">
            <!-- Upload პირდაპირ აქ -->
            <app-upload
              [uploadPath]="uploadPath"
              (uploaded)="onUploaded($event)">
            </app-upload>

            <button class="btn btn-outline-secondary" type="button" (click)="selectedMenuPage && loadItems(selectedMenuPage)" [disabled]="!selectedMenuPage || loadingItems">
              განახლება
            </button>
          </div>

          <div class="text-muted small mt-2" *ngIf="saving">
            <span class="spinner-border spinner-border-sm me-1"></span>
            იტვირთება და ინახება...
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-spinner [loading]="loadingPages || loadingItems" text="იტვირთება..."></app-spinner>

  <div class="alert alert-info" *ngIf="selectedMenuPage && !loadingItems && items.length === 0">
    ამ გვერდზე ჯერ არ არის დამატებული ფოტო/ვიდეო.
  </div>

  <!-- items table -->
  <div class="table-responsive" *ngIf="selectedMenuPage && items.length">
    <table class="table table-bordered table-hover align-middle">
      <thead>
        <tr>
          <th style="width:55px;">#</th>
          <th style="width:60px;">⇅</th>
          <th style="width:110px;">Preview</th>
          <th>Caption</th>
          <th style="width:140px;">ქმედებები</th>
        </tr>
      </thead>

      <tbody cdkDropList [cdkDropListData]="items" (cdkDropListDropped)="drop($event)">
        <tr *ngFor="let item of items; let i = index" cdkDrag>
          <td>{{ i + 1 }}</td>

          <td class="text-center" style="cursor: grab;">
            <span cdkDragHandle title="გადმოათრიე სორტირებისთვის">☰</span>
          </td>

          <td>
            <ng-container [ngSwitch]="item.type">
              <img
                *ngSwitchCase="'image'"
                [src]="getFullUrl(item.src)"
                class="rounded border"
                style="width: 90px; height: 60px; object-fit: cover;"
              />
              <a *ngSwitchCase="'video'" [href]="item.video_url" target="_blank">
                ვიდეო ლინკი
              </a>
            </ng-container>
          </td>

          <td class="small">
            <div class="fw-semibold">{{ item.caption || '—' }}</div>
            <div class="text-muted">type: <code>{{ item.type }}</code></div>
          </td>

          <td>
            <div class="d-flex gap-2">
              <button
                class="btn btn-sm border rounded"
                (click)="toggleVisible(item)"
                [disabled]="togglingId === item.id">
                <span *ngIf="togglingId === item.id" class="spinner-border spinner-border-sm me-1"></span>
                <i class="fi" [ngClass]="item.visible == 1 ? 'fi-rs-eye text-success' : 'fi-rr-eye-crossed text-danger'"></i>
              </button>

              <button
                class="btn btn-sm border rounded"
                (click)="delete(item)"
                [disabled]="deletingIds.has(item.id)">
                <span *ngIf="deletingIds.has(item.id)" class="spinner-border spinner-border-sm me-1"></span>
                <i *ngIf="!deletingIds.has(item.id)" class="fi fi-rr-trash text-danger"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>